import clone from 'lodash/cloneDeep';
import initialState from '../../store/initialState';
import {
  ADD_ROLE_STARTING,
  ADD_ROLE_SUCCESS,
  ADD_ROLE_ERROR,
} from '../../constants/actionTypes';

export default function addRoleReducer(state = initialState.addRole, action) {
  switch (action.type) {
    case ADD_ROLE_STARTING: {
      const newState = clone(state);
      newState.saving = true;
      newState.saved = false;
      return newState;
    }

    case ADD_ROLE_SUCCESS: {
      const { data } = action;

      const newState = clone(state);
      newState.saving = false;
      newState.saved = true;
      newState.error = null;

      newState.newRole = data.role;
      return newState;
    }

    case ADD_ROLE_ERROR: {
      const newState = clone(state);
      newState.saving = false;
      newState.saved = false;
      newState.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}
